import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { PUBLIC_HOME_PATH } from "../public-home-path";
import {
  LEGAL_EFFECTIVE_DATE,
  LEGAL_ENTITY,
  LEGAL_SERVICE_NAME,
  LEGAL_SUPPORT_EMAIL,
  LEGAL_UBI,
} from "./legal-meta";

interface LegalLayoutProps {
  /** Document title, e.g. "Privacy Policy". */
  title: string;
  /** One-line summary shown under the title. */
  lede: string;
  /** Which sibling document to cross-link to in the footer. */
  sibling: { label: string; to: string };
  children: ReactNode;
}

export default function LegalLayout({ title, lede, sibling, children }: LegalLayoutProps) {
  return (
    <main className="page legal-page">
      <article className="card card-wide legal-card">
        <p className="eyebrow">{LEGAL_SERVICE_NAME}</p>
        <h1 className="legal-title">{title}</h1>
        <p className="legal-effective">Last updated: {LEGAL_EFFECTIVE_DATE}</p>
        <p className="legal-lede">{lede}</p>

        <div className="legal-body">{children}</div>

        <footer className="legal-footer">
          <nav className="legal-footer-links" aria-label="Legal navigation">
            <Link to={PUBLIC_HOME_PATH}>Home</Link>
            <Link to={sibling.to}>{sibling.label}</Link>
            <a href={`mailto:${LEGAL_SUPPORT_EMAIL}`}>Contact</a>
          </nav>
          <p className="legal-footer-operator">
            Operator: {LEGAL_ENTITY}. Washington UBI {LEGAL_UBI}.
          </p>
          <p className="legal-footer-note">
            {LEGAL_SERVICE_NAME} is a classroom tool. Schools and teachers direct how it is used with
            students.
          </p>
        </footer>
      </article>
    </main>
  );
}
